import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { AxnAdminSecurityRule } from "@idw-types/data/management-console/axnadmin";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequestWithBody } from "@utils/http-util";
import { injectAxnAdminSecurityRuleId } from "@utils/parameter-injector";

type UpdateAxnAdminSecurityRuleRequestResponse = {
    transferObject: AxnAdminSecurityRule;
};

export const updateAxnAdminSecurityRuleRequest = async (
    original: AxnAdminSecurityRule,
    modified: AxnAdminSecurityRule
): Promise<GenericNetworkResponse<UpdateAxnAdminSecurityRuleRequestResponse>> => {
    const route = injectAxnAdminSecurityRuleId(
        apiRoutes.managementConsole.axnadmin.security.ruleWithId,
        original.id
    );

    const body = {
        id: modified.id,
        idEdit: modified.id,
        className: modified.className ? modified.className : null,
        classNameEdit: modified.className ? modified.className : null,
        pathText: modified.pathText ? modified.pathText : null,
        pathTextEdit: modified.pathText ? modified.pathText : null,
        operationType: modified.operationType,
        operationTypeEdit: modified.operationType,
        status: modified.status,
        statusEdit: modified.status,
        rule: modified.rule ? modified.rule : null,
        ruleEdit: modified.rule ? modified.rule : null,
        ruleName: modified.ruleName ? modified.ruleName : null,
        ruleNameEdit: modified.ruleName ? modified.ruleName : null,
    }

    const { data, error } = await handleRequestWithBody(RequestTypes.PUT, route, body);
    return { data, error, body };
};